import _ from 'lodash';

export class Org {
  constructor(data) {
    this.data = data;
  }

  get(key, defaultValue) {
    return _.get(this.data, key, defaultValue);
  }

  toJSON() {
    return this.data;
  }
}

export class Orgs {
  constructor() {
    this.orgs = {};
  }

  get(id = '') {
    const orgId = id.toLowerCase();
    if (!this.orgs[orgId] || _.isEmpty(this.orgs[orgId].data)) {
      return new Org({});
    }
    return this.orgs[orgId];
  }

  set(id = '', data) {
    const orgId = id.toLowerCase();
    const org = new Org(data);
    this.orgs[orgId] = org;
    return org;
  }

  clear() {
    this.orgs = {};
  }
}

export const orgs = new Orgs();

window.orgs = orgs; // @xxx



// WEBPACK FOOTER //
// ./src/lib/orgs.js